import React, { useEffect, useState } from "react";
import { getDisplayName } from "../utils/metalNameFixer";
import clsx from "clsx";

const GlobalRatesTable = ({ rates }) => {
  const [prevRates, setPrevRates] = useState({});
  const [flashes, setFlashes] = useState({});

  useEffect(() => {
    const newFlashes = {};

    rates.forEach((rate) => {
      const prev = prevRates[rate.name];
      if (prev) {
        ["bid", "ask", "high", "low"].forEach((field) => {
          if (rate[field] !== prev[field]) {
            newFlashes[`${rate.name}-${field}`] =
              rate[field] > prev[field] ? "up" : "down";
          }
        });
      }
    });

    if (Object.keys(newFlashes).length > 0) {
      setFlashes(newFlashes);
      setTimeout(() => setFlashes({}), 700);
    }

    const updatedPrev = {};
    rates.forEach((r) => {
      updatedPrev[r.name] = {
        bid: r.bid,
        ask: r.ask,
        high: r.high,
        low: r.low,
      };
    });
    setPrevRates(updatedPrev);
  }, [rates]);

  return (
    <div className="border rounded-xl shadow-md p-4 bg-black text-white">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-yellow-400 border-b border-yellow-600">
            <th className="py-2">Name</th>
            <th className="py-2">Bid</th>
            <th className="py-2">Ask</th>
            <th className="py-2">High</th>
            <th className="py-2">Low</th>
          </tr>
        </thead>
        <tbody>
          {rates.map((r, i) => (
            <tr key={i} className="text-center border-t border-gray-700">
              <td className="py-2">{getDisplayName(r.name)}</td>
              {["bid", "ask", "high", "low"].map((field) => (
                <td
                  key={field}
                  className={clsx(
                    "py-2 font-semibold transition duration-500",
                    flashes[`${r.name}-${field}`] === "up" && "text-green-400 animate-pulse",
                    flashes[`${r.name}-${field}`] === "down" && "text-red-400 animate-pulse"
                  )}
                >
                  {r[field] || "-"}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default GlobalRatesTable;



